import React, { Component } from 'react';
import FastClone from 'fastest-clone';
import AlertsApiClient from '../stores/AlertsApiClient';
import Alert from '../components/Alert'

export default class AlertsList extends Component {
  
  constructor(props) {
    super(props);
    this.state = this.makeState();
    window.page.list = this;
  }

  componentDidMount() {
    this.loadAlerts();
  }

  loadAlerts() {
    var self = this;
      
    new AlertsApiClient().query(0, 100).then(function (response) {
        var s = self.makeState();
        s.alerts = response.data;
        s.loaded = true;
        self.setState(s);
    });
  }

  handleAlertDelete = (e) => {
    var s = this.makeState();
    for (var i = 0; i < s.alerts.length; i++) {
      if (e.Key === s.alerts[i].Key) {
        s.alerts.splice(i, 1);
        break;
      }
    }
    this.setState(s);
  }

  makeState() {
    var s = {};

    if (this.state == null) {
        s.alerts = [];
        s.loaded = false;
    } else {
        s = new (FastClone.factory(this.state, true))(this.state);
    }

    return s;
  }
  
  render() {

    var alerts = [];
    for (var i = 0; i < this.state.alerts.length; i++) {
      var a = this.state.alerts[i];
      alerts.push(<Alert alert={a} key={a.Key} onDelete={this.handleAlertDelete}/>);
    }

    return (
      <div className="mt20" >
        <ul className="list-group">{alerts}</ul>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/AlertsList.js